import { ref } from '@vue/composition-api';
import { saveAs } from 'file-saver';

import { api } from '@/api/api';

const FILETYPES = {
  csv: 'text/csv',
  excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

export const useDownload = ({ company, filters, userId, type = 'csv' }) => {
  const downloading = ref(false);

  const download = async () => {
    const { from, to, myLinks, otherFilters } = filters;
    const parameters = otherFilters.value.map((f) => [
      f.name,
      f.selected.value.join(';'),
    ]);
    const queryParams = [
      ['created_at_from', from.value],
      ['created_at_to', to.value],
      ...parameters,
    ];
    if (myLinks.value) {
      queryParams.push(['creator', userId]);
    }
    const queryString = queryParams
      .flatMap(([name, value]) => (value ? [`${name}=${value}`] : []))
      .join('&');
    const query = queryString.length > 0 ? `?${queryString}` : '';

    try {
      downloading.value = true;
      const { data, headers } = await api.get(
        `companies/${company.value.currentId}/segments/${company.value.segment.currentId}/export_tracking_links/${query}`,
        {
          responseType: 'blob',
          headers: {
            'X-FileType': FILETYPES[type],
          },
        }
      );
      if (!headers['content-disposition']) {
        return;
      }
      const filename = headers['content-disposition'].split('filename=')[1];
      saveAs(data, filename);
    } catch (error) {
      console.error(error);
    } finally {
      downloading.value = false;
    }
  };

  return {
    downloading,
    download,
  };
};
